((ProductBundle, $) => {
  const $dom = {};
  let productIdArray;
  let lastClickCount = Number(localStorage.getItem('bundleClickCount'));
  let clickCount = `${lastClickCount > 0 ? lastClickCount : 0}`;

  const cacheDom = () => {
    $dom.bundleAtcBtn = $('.product-bundle__atc-btn');
    $dom.productBundleForm = $('.js-product-bundle-form');
    $dom.productBundleItemContainer = $('[data-product-bundle-items]');
  };

  const addProductBundleHandle = (productIds, clickCount) => {
    const bundlePropertyValue = `Bundle Set ${clickCount}`;

    return productIds.forEach((productId) => {
      CartJS.addItem(Number(productId), 1, {
        _bundle: `${bundlePropertyValue}`,
      });
    });
  };

  const buildProductBundleIdArray = () => {
    const productBundleItems = [...$dom.productBundleItemContainer[0].children];
    const itemCount = productBundleItems.length;
    getProductBundleQty(itemCount);
    productIdArray = [...productBundleItems].map((item) => {
      return item.dataset.bundleVariantId;
    });
  };

  const getProductBundleQty = (count) => {
    return (originalBundleItemCount = count);
  };

  const toggleProductBundle = () => {
    return $('#rc_purchase_type_autodeliver').prop('checked') === true ? $dom.productBundleForm.addClass('hide-bundle') : $dom.productBundleForm.removeClass('hide-bundle');
  };

  const bundleProductRemovedHandle = (elem, cart, bundleSet) => {
    const { items } = cart;

    return items.map((item, index) => {
      if (item.properties['_bundle'] === `Bundle Set ${bundleSet}`) {
        CartJS.updateItem(index + 1, 1, (properties = { _: '' }));
      }
    });
  };

  const additionalLineItemHandle = (lineItemId) => {
    CartJS.addItem(Number(lineItemId), 1, {});
  };

  // const checkLocalStorage = () => {
  //   console.log("localStorage", localStorage.getItem("bundleClickCount"));
  // };

  const bindUIActions = () => {
    $(document).on('cart.requestComplete', function(event, cart) {
      const { items } = cart;
      if (items.length === 0) {
        localStorage.removeItem('bundleClickCount');
        clickCount = 0;
      }
    });

    $(document).on('click', '.rc_block__type > input', function() {
      toggleProductBundle();
    });

    $(document).on('click', '.product-bundle__atc-btn', function(e) {
      e.preventDefault();
      clickCount++;
      localStorage.setItem('bundleClickCount', clickCount);
      addProductBundleHandle(productIdArray, clickCount);
    });

    $(document).on('click', '.js-bundle-item-remove', function(e) {
      e.preventDefault();
      const $target = $(this);
      const bundleSet = $target.attr('data-bundle-set');
      setTimeout(function() {
        const cart = CartJS.cart;
        bundleProductRemovedHandle($target, cart, bundleSet);
      }, 1000);
    });

    $(document).on('click', '.js-bundle-qty-minus', function() {
      const $target = $(this);
      const minusQty = Number($target.attr('data-cart-quantity'));
      const bundleSet = $target.attr('data-bundle-set');
      setTimeout(function() {
        const cart = CartJS.cart;
        if (minusQty === 0) {
          bundleProductRemovedHandle($target, cart, bundleSet);
        }
      }, 100);
    });

    $(document).on('click', '.js-bundle-qty-plus', function(e) {
      e.preventDefault();
      if (window.location.pathname.includes('cart') == true) {
        const $lineItemId = $(this)
          .parents('.cart-page__item')
          .attr('data-variant-id');
        additionalLineItemHandle($lineItemId);
      } else {
        const $lineItemId = $(this)
          .parents('.inline-cart-product')
          .attr('data-variant-id');
        additionalLineItemHandle($lineItemId);
      }
    });
  };

  ProductBundle.init = () => {
    cacheDom();
    bindUIActions();
    if (window.location.pathname.includes('products') === true && $('.js-product-bundle-form').length === 1) {
      buildProductBundleIdArray();
    }
    console.log('BVA Module Loaded: ProductBundle');
  };
})((window.ProductBundle = window.ProductBundle || {}), jQuery);
